import Vue from 'vue'
import { QIcon, QRadio, QSvg } from '@qikkeronline/qikker-ui'

Vue.use(QIcon, { isFill: true })
Vue.component('QSvg', QSvg)
Vue.component('QRadio', QRadio)
